import { ZoneSymbolKind } from "@utils/TestUtils";

/** Edge of the square the shapes below are drawn inside. */
export const ZONE_SYMBOL_VIEWBOX_SIZE = 24;

export interface ZoneSymbolShapesProps {
  kind: ZoneSymbolKind;
}

/**
 * Bare SVG artwork for one zone symbol, so the legend and the field map draw
 * the same shapes from one definition. Callers supply the enclosing <svg> or
 * placement group.
 */
export default function ZoneSymbolShapes({ kind }: ZoneSymbolShapesProps) {
  switch (kind) {
    case "normal":
      return <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="2" />;
    case "relative":
      return (
        <g stroke="currentColor" strokeWidth="2.5">
          <line x1="6" y1="6" x2="18" y2="18" />
          <line x1="18" y1="6" x2="6" y2="18" />
        </g>
      );
    case "absolute":
      return <rect x="5" y="5" width="14" height="14" fill="currentColor" />;
    default:
      return <circle cx="12" cy="12" r="3" fill="gray" />;
  }
}
